import { render, staticRenderFns } from "./showPoster.vue?vue&type=template&id=3c445d26&scoped=true&"
import script from "./showPoster.vue?vue&type=script&lang=js&"
export * from "./showPoster.vue?vue&type=script&lang=js&"
import style0 from "./showPoster.vue?vue&type=style&index=0&id=3c445d26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c445d26",
  null
  
)

export default component.exports